import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import SearchableRestrictedProviderSelect from './SearchableRestrictedProviderSelect';
import { fetchAllRestrictedProvidersBasicInfo } from '../services/api';

function ProviderRestrictedSearchBar(props) {
  const {
    disabled,
    onSelect,
    errorMessage,
    allowSendToQwell,
    customFilter = null,
    clearable=true,
    value,
    label = "For Provider",
    name = "provider",
    noOptionsMessage="Start typing for options",
    placeholder = "Search for a provider...",
    maxOptions = 20,
    searchable = true,
    practiceId = null,
    getProviderInfo,
    searchvalueClear,
    classes: {
      selectInput
    }
  } = props;



  const [providers, setProviders] = useState([]);
  const [currentProviderId, setCurrentProviderId] = useState(value);

  // loading provider names
  useEffect(() => {
    (async () => {
      const allProvidersBasicInfo = await fetchAllRestrictedProvidersBasicInfo(practiceId);
      const providerList = allProvidersBasicInfo.map(p => ({
        label: p.fullTitle,
        value: p.id,
        info: p,
      }))
      if (allowSendToQwell) providerList.push({
        label: 'Send to Qwell',
        value: 'send-to-qwell',
        info: { id: 'send-to-qwell' },
      });
      setProviders(providerList);
    })();
  }, [])

  useEffect(()=>{
      if(searchvalueClear !== null){
        setCurrentProviderId(null)
      }
  },[searchvalueClear]);

  useEffect(() => {
    (async () => {
      const allProvidersBasicInfo = await fetchAllRestrictedProvidersBasicInfo(practiceId);
      const providerList = allProvidersBasicInfo.map(p => ({
        label: p.fullTitle,
        value: p.id,
        info: p,
      }))
      if (allowSendToQwell) providerList.push({
        label: 'Send to Qwell',
        value: 'send-to-qwell',
        info: { id: 'send-to-qwell' },
      });
      setProviders(providerList);
    })();
  }, [getProviderInfo])

  // filtering provider names provider names appropriately when search bar is typed into
  const filterProviders = async providerName => {
    return providers.filter(customFilter || ((provider) =>
      provider.label.toLowerCase().includes(providerName.toLowerCase())
    )).slice(0, maxOptions);
  };

  const handleSelectionBeingMade = async (provider) => {
    if (provider) {
      setCurrentProviderId(provider.id)
      await onSelect(provider.info)
    } else {
      setCurrentProviderId(null)
      await onSelect(null)
    }
  }

  return (
    <SearchableRestrictedProviderSelect
      noOptionsMessage={noOptionsMessage}
      clearable={clearable}
      disabled={disabled}
      searchable={searchable}
      fetchAsyncOptions={filterProviders}
      placeholder={placeholder}
      label={label}
      name={name}
      onChange={handleSelectionBeingMade}
      value={currentProviderId}
      options={[]}
      className={selectInput}
      error={!!errorMessage}
      errorMessages={errorMessage}
    />
  );
}

ProviderRestrictedSearchBar.propTypes = {
  onSelect: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  customFilter: PropTypes.func,
  placeholder: PropTypes.string,
  practiceId: PropTypes.string,
  label: PropTypes.string,
  errorMessage: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string,
  maxOptions: PropTypes.number,
  searchable: PropTypes.bool,
  disabled: PropTypes.bool,
}

const styles = () => ({
  selectInput: {
    marginTop: '0.5em',
    marginBottom: '1em',
  },
});

export default withStyles(styles)(ProviderRestrictedSearchBar);
